import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { PERMISSION_LIST } from 'common/constants/permissions';

export default () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();

    const options = [
        {
            label: t('Product', { count: 2 }),
            permission: [PERMISSION_LIST.ALLIANCE_PRODUCTS_PERMISSION],
            selected: ['/financial'].includes(pathname),
            to: '/financial',
        },
        {
            label: t('Template', { count: 2 }),
            selected: ['/templates', '/edit-template'].includes(pathname),
            to: '/templates',
        },
    ];

    return options;
};
